import { render, staticRenderFns } from "./CaseStudyVivoCobranca.vue?vue&type=template&id=5b88939c&scoped=true"
import script from "./CaseStudyVivoCobranca.vue?vue&type=script&lang=js"
export * from "./CaseStudyVivoCobranca.vue?vue&type=script&lang=js"
import style0 from "./CaseStudyVivoCobranca.vue?vue&type=style&index=0&id=5b88939c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b88939c",
  null
  
)

export default component.exports